import { PaymentConfirmationComponent } from '../EventBooking/BookingComponents'
import { useLocation } from 'react-router-dom'

export default function BookingSuccessfulPage() {
  const location = useLocation()
  const data = location?.state

  const eventDetailOfRequestedEvent = data?.eventDetailOfRequestedEvent
  const chosenSlotData = data?.chosenSlotData
  const fromOnboarding = data?.fromOnboarding
  const professionalData = data?.professionalData
  const openedAsWebview = data?.openedAsWebview
  const bundleBuyingWaitingState = data?.bundleBuyingWaitingState

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <PaymentConfirmationComponent
        bookingEventDetails={eventDetailOfRequestedEvent}
        chosenSlotData={chosenSlotData}
        fromOnboarding={fromOnboarding}
        professionalData={professionalData}
        hideHomeButton={sessionStorage.getItem('isThisWebviewSession') || openedAsWebview}
        bundleBuyingWaitingState={bundleBuyingWaitingState}
        isWebview={sessionStorage.getItem('isThisWebviewSession') || openedAsWebview}
      />
    </div>
  )
}
